import { render, staticRenderFns } from "./updateGiftCard.vue?vue&type=template&id=23736f92"
import script from "./updateGiftCard.vue?vue&type=script&lang=js"
export * from "./updateGiftCard.vue?vue&type=script&lang=js"
import style0 from "./updateGiftCard.vue?vue&type=style&index=0&id=23736f92&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports